import { MarketStatus } from '@ps/isp-web-services-types';
import { notEmpty } from '@ps/web-core-utils';
import produce from 'immer';
import { isEmpty } from 'lodash';

import type { MarketPollingData } from '@swf/sports/types/market';
import updateMarket from '@swf/sports/utils/updateMarket';

import { defaultState } from './defaultState';
import type { AntePostMarketHandlerResponseBody } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  antePostMarketRequested: (
    state: State,
    { isBackgroundLoading = false }: { isBackgroundLoading?: boolean } = {}
  ): State => ({
    ...state,
    isLoading: !isBackgroundLoading
  }),
  dataLoadSuccess: (state: State, payload: AntePostMarketHandlerResponseBody): State => {
    if (isEmpty(payload.markets) && isEmpty(payload.templates)) {
      return {
        ...state,
        isLoading: false,
        hasPreloaded: true,
        errorCode: undefined,
        hasAntePostMarketClosed: true
      };
    }
    return {
      ...state,
      ...payload,
      isLoading: false,
      hasPreloaded: true,
      errorCode: undefined,
      hasAntePostMarketClosed: false
    };
  },
  dataLoadFailed: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    errorCode: payload
  }),
  marketsUpdated: (state: State, { data: marketUpdates, closed }: MarketPollingData) =>
    produce(state, (draft) => {
      // Update the markets with new data
      Object.values(draft.markets)
        .filter(notEmpty)
        .forEach((market) => {
          if (closed.includes(market.marketId)) {
            market.marketStatus = MarketStatus.CLOSED;
            return;
          }

          Object.entries(marketUpdates).forEach(([marketUpdateId, marketUpdate]) => {
            if (market.marketId === marketUpdateId && marketUpdate) {
              updateMarket(market, marketUpdate);
            }
          });
        });

      return draft;
    })
};
